import { Component, Input } from '@angular/core';

@Component({
  selector: 'illustration-page-layout',
  templateUrl: './illustration-page-layout.component.html',
  styleUrls: ['./illustration-page-layout.component.scss']
})
export class IllustrationPageLayoutComponent {
  @Input() title: string;
  @Input() logoUrl: string;
}
